function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".b{fill:none}.b{stroke:rgba(0,0,0,0.12);stroke-linecap:round;stroke-width:2px}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  strokeLinejoin: "round",
  fill: "none"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M5.479 0h69.042A5.435 5.435 0 0180 5.39v44.2a5.435 5.435 0 01-5.479 5.39H29.947L16.514 69.116a1.489 1.489 0 01-1.832.781c-1.22-.464-.678-2.26-.678-2.26l-.09-12.654H5.479A5.435 5.435 0 010 49.591V5.39A5.435 5.435 0 015.479 0z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M5.47944641 2C3.56086731 2 2 3.52090454 2 5.3903656v44.20101166c0 1.86945343 1.56086731 3.39037323 3.47944641 3.39037323h8.43405151c1.09898377 0 1.99208832.88674164 1.9999466 1.98570633l.08425903 11.78812027 12.50000382-13.15167237c.37756347-.39724731.90161133-.62215423 1.44966888-.62215423H74.5205536C76.43913269 52.98175049 78 51.46083069 78 49.59137726V5.3903656C78 3.52090454 76.43913269 2 74.52055359 2H5.4794464m0-2H74.5205536C77.54676819 0 80 2.41335297 80 5.3903656v44.20101166c0 2.97702026-2.45323181 5.39037323-5.47944641 5.39037323H29.94737625L16.51382446 69.11564636s-.43497467.88433838-1.30212402.88433838c-.16169739 0-.33831787-.03071594-.53006744-.10366058-1.220047-.46411133-.6776886-2.26016999-.6776886-2.26016999l-.09044648-12.65440368h-8.4340515C2.45323181 54.98175049 0 52.56839752 0 49.59137726V5.3903656C0 2.41335297 2.45323181 0 5.47944641 0z",
  fill: "rgba(0,0,0,0.12)"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "b",
  d: "M15.5 15.754h50M15.5 26.449h50M15.5 37.145h30"
});

var SvgSmsBig = function SvgSmsBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 80,
      height: 70,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgSmsBig, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/SMSBig.55d7d37b.svg";
export { ForwardRef as ReactComponent };